import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpHeaders } from '@angular/common/http';

import { Subject } from 'rxjs';
import { Observable } from 'rxjs';
import { BehaviorSubject } from 'rxjs';
import { throwError } from 'rxjs';

// import 'rxjs/add/operator/catch';
import { takeUntil,catchError } from 'rxjs/operators';


// services
import { ErrorHandler } from './error-handler.service';
import { UtilityService } from './utility.service';

// path globals
import { API_PATH, SUBSCRIPTION_KEY, GET_TOKEN_DATA, GET_LEAD_IN_SESSION, COMPLETE_BOOKING, BOOKING_DETAILS_LITE, GET_RETURN_SESSION } from '../globals';
//import { error } from 'node:console';

interface TokenRequest {
  token: string;
}

@Injectable({
  providedIn: 'root',
})
export class UrlParamsService {

  private _token;
  private _destroyed$ = new Subject<boolean>();
  private _destroyedErr$ = new Subject<boolean>();
  private _httpObj = null;
  private _hasError = false;
  private _parsedSessionData;

  public routeParams$: Subject<any> = new Subject();
  public bookingSummaryItemSubject$: BehaviorSubject<any> = new BehaviorSubject(null);
  public trackingDetailsSubject$: Subject<any> = new Subject();
  public sessionParamsData$: Subject<any> = new Subject();
  public queryParams$: BehaviorSubject<any> = new BehaviorSubject(null);
  public paramData;

  constructor (
    private _http: HttpClient,
    private _errorService: ErrorHandler,
    private _utilityService: UtilityService
  ) {}

  createAuthorizationHeader(headers: HttpHeaders, tokenFromCall?) {
    const userToken = typeof this._token === 'undefined' ? tokenFromCall : this._token;
    headers = headers.set('Authorization', 'bearer ' + userToken);
    return headers;
  }

  createCustomAuthorizationHeader(headers: HttpHeaders) {
    const value =  this._utilityService.csHead$.getValue();
    headers = headers.set('API_KEY', value);
    return headers;
  }

  sendParamsToApi(data: any) {

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    const headers = new HttpHeaders()
    .set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

    const request: TokenRequest = { token: data };
    this._http
      .post(API_PATH + GET_TOKEN_DATA, request, {headers:headers})
      .subscribe((res:any) => {
        this.routeParams$.next(res);
      },
      err => {
        // this.routeParams$.next(Observable.throw(err));
        this.routeParams$.next(err);

        this._errorService.handleError(err);
        return;
      });
  }

  getBookingSummaryItem(bookingRef: string, token) {

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    let headers = new HttpHeaders();
    headers = headers.set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    headers = this.createAuthorizationHeader(headers, token);
    const query = {
      bookingReference: bookingRef,
      showCancelledBookings: true,
    };

    this._http.post(API_PATH + COMPLETE_BOOKING, query, {headers: headers})
      .subscribe(
        (res:any) => {
          this.bookingSummaryItemSubject$.next(res);
        },
        err => {
          // this.bookingSummaryItemSubject$.next(Observable.throw(err));
          this.bookingSummaryItemSubject$.next(err);

          this._errorService.handleError(err);
          return;
        });
  }

  setHttpAuth(obj) {
    this._httpObj = obj;
    this._utilityService.csHead$
      .pipe(takeUntil(this._destroyed$))
      .subscribe(res => {
        if (res !== null) {
          // this.setHttpCall(obj);
          if (obj.type === 'getTrackingDetails') {
            this.getTrackingDetails(obj.bookingRef, obj.name, obj.email);
          }
          this._destroyed$.next(true);
          this._destroyed$.complete();
        }
      });
  }

  getTrackingDetails(bookingRef: string, name: string, email: string) {

    const query = {
      bookingReference: bookingRef,
      passengerLastName: name,
      userEmailAddress: email
    };

    // const headers = new HttpHeaders();
    // headers.append('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);
    let headers = new HttpHeaders()
    .set('Ocp-Apim-Subscription-Key', SUBSCRIPTION_KEY);

    headers =this.createCustomAuthorizationHeader(headers);

    this._http.post(API_PATH + BOOKING_DETAILS_LITE, query, {headers: headers})
      .subscribe(
        (res:any) => {
          this.trackingDetailsSubject$.next(res);
        },
        err => {
          // bad api key
          if (err.validationErrorMessages[0].code === 999) {
            // this._hasError = true;
            const oldKey = this._utilityService.csHead$.getValue();
            this._utilityService.cs();
            this._utilityService.csHead$
              .pipe(takeUntil(this._destroyedErr$))
              .subscribe(res => {
                if (res !== oldKey) {
                  this._hasError = false;
                  this.setHttpAuth(this._httpObj);
                  this._destroyedErr$.next(true);
                  this._destroyedErr$.complete();
                }
              });
          } else {
            // this.trackingDetailsSubject$.next(Observable.throw(err));
            this.trackingDetailsSubject$.next(err);
            this._errorService.handleError(err);
            return;
          }

        });

  }

  // getSessionsData(data: any, isReturnSession) {

  //   let path = '';
  //   let qPath = '';
  //   if (isReturnSession) {
  //     path = GET_RETURN_SESSION;
  //     qPath = '?returnSessionId=';
  //   } else {
  //     path = GET_LEAD_IN_SESSION;
  //     qPath = '?sessionId=';
  //   }

  //   this._http
  //   .get(API_PATH + path + qPath + data)
  //   .subscribe(res => {
  //     this._parsedSessionData = res;
  //     this.sessionParamsData$.next(res);
  //   },
  //   err => {
  //     this.sessionParamsData$.next(Observable.throw(err));
  //     this._errorService.handleError(err);
  //     return;
  //   });

  // }

  parseReturnedData(value: any) {
    console.log(value,'val');

    const parsed = JSON.parse(value);
   console.log(parsed,'parsed');

    return parsed;
  }

  setParamData(data: any) {
    this.paramData = data;
  }
  getParamData() {
    return this.paramData;
  }
}
